import classNames from "classnames";
import Skeleton from "react-loading-skeleton";
import TrashIcon from "~/assets/svgs/trash.svg";
import Text from "~/components/Text";
import { Product } from "~/services/product";
import {
  ALL_VISIBLE_THEMES,
  getConfig,
  getTheme,
  isUsingLayoutV2,
} from "~/utils/theme";
import styles from "./ProductItem.module.scss";
import TooltipTwo from "~/components/TooltipTwo";
import Colors from "~/constants/colors";
import RewardIcon from "~/assets/svgs/reward.svg";
import { useMemo } from "react";

export type Props = {
  data: Product | any;
  loading?: boolean;
  onRemove?: (e: any) => void;
  className?: string;
  href?: string;
  isBestSeller?: boolean;
};

const ProductImage = ({
  data,
  loading,
  onRemove,
  href,
  isBestSeller,
}: Props) => {
  const themeConfig = getConfig("ProductItem");
  const currentTheme = getTheme();

  const badgeColorByTheme = useMemo(() => {
    switch (currentTheme) {
      case ALL_VISIBLE_THEMES.Dunkare:
        return "bg-[#EB5713] text-white";
      case ALL_VISIBLE_THEMES.Ireishprint:
        return "bg-[#B03636] text-white";
      case ALL_VISIBLE_THEMES.AmareBox:
        return "bg-[#c96a6c] text-white";
      default:
        return "bg-primary text-[#FDFD00]";
    }
  }, [currentTheme]);

  return (
    <a href={href || undefined} className="overflow-hidden cursor-pointer">
      <div className={styles.back_img}>
        {loading !== undefined && !!loading && !data.images?.[0] && (
          <Skeleton
            className="aspect-square"
            containerClassName="w-full h-full"
          />
        )}
        {
          isBestSeller && (
            <div
              className={`absolute top-4 right-[-44px] xs:top-0 rotate-45 ${badgeColorByTheme} font-bold px-10 py-1 shadow-lg z-20 italic text-xs`}
            >
              🔥 Best Seller
            </div>
          )
          // (isUsingLayoutV2 ? (
          // ) : (
          //   <div className="absolute right-1 top-4 z-[2]">
          //     <TooltipTwo
          //       id="best-seller"
          //       title={
          //         <Text className="w-[200px]">
          //           This item has had a high sales volume over the past 6
          //           months.
          //         </Text>
          //       }
          //     >
          //       <div className="inline-flex items-center rounded-full bg-amber-100 px-2 py-1 text-sm font-medium shadow">
          //         <RewardIcon width={24} height={24} color={Colors.PRIMARY} />
          //         <Text color={Colors.PRIMARY}>Bestseller</Text>
          //       </div>
          //     </TooltipTwo>
          //   </div>
          // ))
        }
        {data?.images?.[0] && (
          <img
            src={data.images?.[0]}
            // loader={({ src, width }) => {
            //   return `${src}?w=${width}`;
            // }}
            alt={data?.name || "Product Image"}
            className="object-contain"
            loading="lazy"
            // decoding="async"
            sizes="(max-width: 600px) 100px, 200px"
            title={data?.name || "Product Image"}
            height="100%"
            width="100%"
            style={{
              height: "100%",
              width: "100%",
            }}
            // layout="fill"
          />
        )}
      </div>
      <div className={styles.front_img}>
        {!!loading && !data.thumbnail?.url && (
          <Skeleton
            className="aspect-square"
            containerClassName="w-full h-full"
          />
        )}
        {
          isBestSeller && (
            <div
              className={`absolute top-4 right-[-44px] xs:top-0 rotate-45 ${badgeColorByTheme} font-bold px-10 py-1 shadow-lg z-20 italic text-xs`}
            >
              🔥 Best Seller
            </div>
          )
          // (isUsingLayoutV2 ? (
          // ) : (
          //   <div className="absolute right-1 top-4 z-[2]">
          //     <TooltipTwo
          //       id="best-seller"
          //       title={
          //         <Text className="w-[200px]">
          //           This item has had a high sales volume over the past 6
          //           months.
          //         </Text>
          //       }
          //     >
          //       <div className="inline-flex items-center rounded-full bg-amber-100 px-2 py-1 text-sm font-medium shadow">
          //         <RewardIcon width={24} height={24} color={Colors.PRIMARY} />
          //         <Text color={Colors.PRIMARY}>Bestseller</Text>
          //       </div>
          //     </TooltipTwo>
          //   </div>
          // ))
        }
        {(data.image?.url || data.thumbnail?.url) && (
          <img
            src={data.thumbnail?.url ? data.thumbnail?.url : data.image?.url}
            // loader={({ src, width }) => {
            //     return `${src}?w=${width}`;
            // }}
            alt={data?.name || "Product Image"}
            className="object-contain"
            loading="lazy"
            // decoding="async"
            title={data?.name || "Product Image"}
            height="100%"
            width="100%"
            style={{
              height: "100%",
              width: "100%",
            }}
          />
        )}
      </div>
      {!loading && (
        <div
          className={classNames(styles.tags, styles[themeConfig.badgeStyle])}
        >
          {data.badges?.map((badge: string) => (
            <div
              key={badge}
              className={classNames(styles.tag_item, styles[badge])}
            >
              <Text>{badge}</Text>
            </div>
          ))}
        </div>
      )}
      {onRemove && (
        <div onClick={onRemove} className={"inline-block"}>
          <TrashIcon
            className={classNames(
              styles.remove_icon,
              styles[themeConfig.badgeStyle]
            )}
            width={24}
            height={24}
          />{" "}
        </div>
      )}
    </a>
  );
};

export default ProductImage;
